import { upDataAccountChangePassword } from '@/apis/account'
import { CommonFormEdit, CommonRule } from '@/components/LoongIn'
import { getClientHeight } from '@/store/slices/appSlice'
import { useI18n } from '@/hooks/useLocale'
import { useMountedState } from '@/hooks/useMountedState'
import React, { useState, useEffect, forwardRef } from 'react'
import { useSelector } from 'react-redux'
export const EditPasswordForm = forwardRef(
  ({ id, formData, onSubmit, onCancel, event, extraData, disabled }, ref) => {
    const [rules, setRules] = useState({})
    const t = useI18n()
    const [formItem, setFormItem] = useState([])
    const [innerData, setInnerData] = useState({})
    const isMounted = useMountedState()
    //获取客户区高度
    const clientHeight = useSelector(getClientHeight)
    //初始化数据
    const initData = {}
    useEffect(() => {
      if (!isMounted()) return
      setInnerData(formData)
    }, [formData])
    const onChange = (data) => {
      setInnerData(data)
    }
    useEffect(() => {
      if (!isMounted()) return
      changeFormItem()
    }, [innerData])
    //表单数据项

    const changeFormItem = () => {
      setFormItem([
        {
          type: 'password',
          dataType: 'text',
          label: t('user.currentPassword'),
          fieldName: 'currentPassword',
        },
        {
          type: 'password',
          dataType: 'text',
          label: t('user.newPassword'),
          fieldName: 'newPassword',
        },
        {
          type: 'password',
          dataType: 'text',
          label: t('user.confirmPassword'),
          fieldName: 'onceMoreNewPassword',
        },
      ])
    }
    //表单的校验规则
    useEffect(() => {
      if (!isMounted()) return
      const newrules = {
        newPassword: [CommonRule.Require],
        onceMoreNewPassword: [CommonRule.Require],
        currentPassword: [CommonRule.Require],
      }
      setRules(newrules)
    }, [])

    //获取更新时的参数
    const getUpdateInput = (inputdata) => {
      if (inputdata.onceMoreNewPassword != inputdata?.newPassword) {
        throw ''
      }
      return {
        currentPassword: inputdata.currentPassword,
        newPassword: inputdata.newPassword,
      }
    }

    //获取添加时的参数
    const getCreateInput = (inputdata) => {
      if (inputdata.onceMoreNewPassword != inputdata?.newPassword) {
        throw ''
      }
      return {
        currentPassword: inputdata.currentPassword,
        newPassword: inputdata.newPassword,
      }
    }
    //返回页面
    return (
      <CommonFormEdit
        // type="dialog"
        title={t('user.editPassword')}
        panelTitle={t('user.editPassword')}
        showHead={false}
        formItem={formItem}
        initData={initData}
        rules={rules}
        createData={upDataAccountChangePassword}
        updateData={upDataAccountChangePassword}
        getUpdateInput={getUpdateInput}
        getCreateInput={getCreateInput}
        id={1}
        formData={innerData}
        onSubmit={onSubmit}
        onCancel={onCancel}
        height={400}
        width={400}
        onChange={onChange}
        event={event}
        zIndex={203}
        disabled={disabled}
        labelCol={{
          flex: '140px',
        }}
      ></CommonFormEdit>
    )
  }
)

